import en from './en';

const ja = {
  ...en,
  languageSwitcher: {
    label: '言語',
    options: {
      en: 'EN',
      ja: 'JA',
      ko: 'KO',
      ms: 'MS',
      th: 'TH',
      tr: 'TR',
    },
    names: {
      en: '英語',
      ja: '日本語',
      ko: '韓国語',
      ms: 'マレー語',
      th: 'タイ語',
      tr: 'トルコ語',
    },
  },
  nav: {
    home: 'ホーム',
    privacy: 'プライバシー',
    terms: '利用規約',
    smsOptIn: 'SMS認証',
    guidelines: 'ガイドライン',
    safety: '安全',
    deleteAccount: 'アカウント削除',
    support: 'サポート',
    download: 'ダウンロード',
    brandAriaLabel: '7Loves ホーム',
    menuAriaLabel: 'メニューを開く',
  },
  store: {
    groupAriaLabel: 'ストアリンク',
    appStoreAriaLabel: 'App Storeでダウンロード',
    appStoreOverline: 'App Storeで',
    appStoreTitle: 'ダウンロード',
    googlePlayAriaLabel: 'Google Playで入手',
    googlePlayOverline: 'Google Playで',
    googlePlayTitle: 'ダウンロード',
  },
  home: {
    metaTitle: 'ホーム',
    title: '7Lovesへようこそ',
    subtitle: 'Blind Date - まずマッチして、もっと多くを少しずつ知ろう。',
    intro:
      'Seven Lovesは、意味のあるつながりに焦点を当てたモダンなデーティングアプリです。従来のスワイプ型アプリとは異なり、Seven Lovesでは、先につながり、その後プロフィールが徐々に公開されるユニークなブラインドマッチ体験を提供します。',
    howItWorks: '使い方',
    details:
      'ユーザーは相性に基づいてマッチし、会話を始め、時間の経過とともにプロフィール情報が解放されます。この仕組みにより、表面的なスワイプではなく、より本物のつながりが生まれます。',
    primaryCta: 'ダウンロード',
    secondaryCta: 'お問い合わせ',
  },
  downloadPage: {
    metaTitle: 'ダウンロード',
    title: '7Lovesを入手',
    subtitlePrefix: 'ここから',
    subtitleSuffix: 'に進めます。',
    fallback: '必要であれば下のストアリンクも利用できます。',
    modalTitle: 'ストアを開きますか？',
    modalBodyPrefix: 'この端末で',
    modalBodySuffix: 'を開いてみます。',
    primaryCta: 'ストアを開く',
    secondaryCta: '今はしない',
    backHome: 'ホームに戻る',
    destinations: {
      ios: 'App Store',
      android: 'Google Play',
    },
  },
  smsOptIn: {
    metaTitle: 'SMS認証の同意',
    title: 'SMS認証の同意',
    subtitle:
      'ワンタイム認証コードを受け取るには、18歳以上であることを確認し、携帯電話番号を入力してください。',
    dobLabel: '生年月日 (DD/MM/YYYY)',
    dayPlaceholder: 'DD',
    monthPlaceholder: 'MM',
    yearPlaceholder: 'YYYY',
    phoneLabel: '携帯電話番号',
    phonePlaceholder: '+81 90 0000 0000',
    sendCode: '認証コードを送信',
    disclosure:
      '「認証コードを送信」をタップすると、18歳以上であることを確認し、認証目的でSeven Lovesから送信されるワンタイムSMS認証コードの受信に同意したことになります。通信料がかかる場合があります。マーケティングメッセージは送信されません。',
    privacyLink: 'プライバシーポリシー',
  },
  pages: en.pages,
};

export default ja;
